/* eslint-disable prettier/prettier */
/* eslint-disable */

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import RotatingCard from "examples/Cards/RotatingCard";
import RotatingCardFront from "examples/Cards/RotatingCard/RotatingCardFront";
import RotatingCardBack from "examples/Cards/RotatingCard/RotatingCardBack";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

// Images
import bgFront from "assets/images/hjem/t-event-rotate-card-front.jpg";
import bgBack from "assets/images/hjem/t-event-rotate-card-back.jpg";

function Information() {
  return (
    <MKBox component="section" py={6} my={6}>
      <Container>
        <Grid container item xs={11} spacing={3} alignItems="center" sx={{ mx: "auto", pr:3}}>
          {/* Roterende kort: Leie utstyr eller DJ */}
          <Grid item xs={12} lg={4} sx={{ mx: "auto"}}>
            <RotatingCard>
              <RotatingCardFront
                image={bgFront}
                icon="audiotrack"
                title={
                  <>
                    Lei lyd, lys
                    <br />
                    eller DJ?
                  </>
                }
                description="Vi tilbyr profesjonell utleie av lyd- og lysutstyr til arrangementer på Helgeland, samt DJ-tjenester som skaper den perfekte stemningen."
              />
              <RotatingCardBack
                image={bgBack}
                title="Oppdag mer"
                description="Enten du trenger utstyr til russefest, skoleball, bryllup eller firmaevent – vi har det du trenger. Vi leverer også DJ-tjenester!"
                action={{
                  type: "internal",
                  route: "/utleie",
                  label: "Les mer",
                }}
              />
            </RotatingCard>
          </Grid>

          {/* Informasjonskort */}
          <Grid item xs={12} lg={7} sx={{ ml: "auto" }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="music_note"
                  title="Profesjonell lyd"
                  description="Fra små fester til store konserter – vårt utstyr sikrer topp lydkvalitet."
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="lightbulb"
                  title="Fantastisk lys"
                  description="Lys skaper stemning! Vi har alt fra enkle festlys til avanserte lysshow."
                />
              </Grid>
            </Grid>
            <Grid container spacing={3} sx={{ mt: { xs: 0, md: 6 } }}>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="event"
                  title="Passer alle events"
                  description="Russefester, skoleball, bryllup, julebord, firmaevent – vi har utstyret og folkene for deg."
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="headset_mic"
                  title="DJ-tjenester"
                  description="Erfarne DJ-er med lang fartstid – vi spiller musikken som passer perfekt til ditt arrangement."
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
